const AVATARS = [
  "oklch(0.62 0.13 275)",
  "oklch(0.6 0.12 200)",
  "oklch(0.62 0.12 40)",
  "oklch(0.55 0.1 320)",
  "oklch(0.5 0.08 160)",
  "oklch(0.45 0.05 240)",
];

export function avatarColor(key) {
  const s = String(key || "");
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return AVATARS[h % AVATARS.length];
}

export function initials(name) {
  const n = String(name || "?").trim();
  if (!n) return "?";
  const parts = n.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return n.slice(0, 1).toUpperCase();
}

export function shortId(id) {
  const s = String(id || "");
  if (s.length <= 20) return s;
  return `${s.slice(0, 8)}…${s.slice(-8)}`;
}

export function shortName(name) {
  const s = String(name || "Participant");
  if (s.length <= 18) return s;
  return `${s.slice(0, 6)}…${s.slice(-4)}`;
}

export function formatElapsed(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(s / 60);
  const h = Math.floor(m / 60);
  const mm = String(m % 60).padStart(2, "0");
  const ss = String(s % 60).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}

export function formatClock(ts = Date.now()) {
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString(undefined, {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function isHttpUrl(value) {
  return typeof value === "string" && /^https?:\/\//i.test(value.trim());
}

export function parsePunkId(value) {
  if (value == null || value === "") return null;
  if (typeof value === "object") return null;
  const n = Number(value);
  if (!Number.isInteger(n) || n < 0 || n > 9999) return null;
  return n;
}

export function punkImageUrls(punkId) {
  const n = parsePunkId(punkId);
  if (n == null) return [];
  const pad = String(n).padStart(4, "0");
  return [
    `https://www.larvalabs.com/cryptopunks/cryptopunk${n}.png`,
    `https://www.larvalabs.com/public/images/cryptopunks/punk${pad}.png`,
  ];
}

export function isLiveRoom(room) {
  return Number(room?.participants || 0) > 0;
}
